/* eslint-disable react/jsx-indent */
import { Autocomplete, TableCell, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { FC } from 'react';
import TextField from 'components/text-field';
import { Controller, useFormContext } from 'react-hook-form';
import { ChargeFormEntry } from '../../../../types';
import { ListingEntry } from 'graphql/listings/queries';
import { extractData } from 'views/orders/new-charges/charges-e/components/document-fees-modal/services';
import { ChargesFormType } from '../../../../hooks';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.default,
      borderRadius: '5px',
      color: theme.palette.primary.dark,
      fontSize: '0.8rem',

      '& .MuiOutlinedInput-input': {
        padding: '10px !important',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'unset',
      },
    },
  },
  tableChargeRow: {
    padding: `8px ${theme.spacing(0.5)}`,
    fontSize: '0.8rem',
  },
}));

interface Props {
  charge: ChargeFormEntry;
  index: number;
}

export const EndorsementCodeField: FC<Props> = ({
  index,
  charge,
}) => {
  const classes = useStyles();

  if (charge.code.match(/^(owners|lenders)_\d+$/)) {
    const code = charge.code.split("_")[1];
    return (
      <Tooltip title={code}>
        <TableCell
          className={classes.tableChargeRow}
          style={{ paddingLeft: '10px', cursor: 'default', textAlign: "center" }}
        >
          {code}
        </TableCell>
      </Tooltip>
    );
  }

  return (
    <TableCell className={classes.tableChargeRow}>
      <Typography>-------------</Typography>
    </TableCell>
  );
};
